import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const PageNotFound = () => {
  const history = useHistory();

  useEffect(() => {
    const timer = setTimeout(() => {
      history.push('/');
    }, 2000);

    return () => clearTimeout(timer);
  }, [history]);

  return <main>
    <section className="page-not-found">PageNotFound!!!</section>
  </main>;
};

export default PageNotFound;
